<template>
    <!--  -->
    <div class="flex flex-col items-center bg-white shadow-custom rounded-lg w-full">
        <!--  -->
        <loading :active.sync="loading" :is-full-page="fullPage"></loading>
        <!--  -->

        <!--  -->
        <div class="flex items-center justify-between w-full p-4">
            <!--  -->
            <div class="flex">
                <div class="h-8 w-1 rounded-lg mr-4 bg-primary-600" />
                <p class="text-xl">{{ statSubtitle }}</p>
            </div>
            <!--  -->

            <!--  -->
            <div v-if="sellers && userType && userType.type != 'Seller'" class="relative w-1/5 mt-2 flex order-0 float-right">
                <!--  -->
                <div class="border hover:border-orange-400 w-full focus-within:border-orange-500 focus-within:text-orange-500 transition-all duration-500 relative rounded-lg p-1">
                    <!--  -->
                    <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                        <p>
                            <label for="status" class="bg-white text-gray-700 px-1">{{ $t('seller') }} :
                                <span :class="$colors.required">*</span>
                            </label>
                        </p>
                    </div>
                    <!--  -->

                    <!--  -->
                    <p>
                        <v-select v-model="timeserchsellerselect" :options="sellers" label="company" placeholder="Seller ..." @input="ChangeSeller"></v-select>
                    </p>
                    <!--  -->
                </div>
                <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div class="relative flex items-center justify-between">
                <!--  -->
                <div class="relative flex items-center order-1 float-right">
                    <!--  -->
                    <div v-if="filter" class="h-10 flex gap-1 transition-all duration-500 relative rounded p-1">
                        <!--  -->
                        <button class="rounded-md border-2 text-xs hover:bg-orange-100 px-2 py-1" :name="action" :class="timeserchtype == 'all' ? 'border-orange-500' : 'text-gray-600  border-gray-600'" value="all" @click="ChangeTypeDateRevenu($event); timeserchtype = 'all';">All</button>
                        <!--  -->

                        <!--  -->
                        <button class="rounded-md border-2 hover:bg-orange-100 border-orange-50 px-2 py-1" :name="action" :class="timeserchtype == 'betweendate' ? 'border-orange-500' : 'text-gray-600 border-gray-600'" value="betweendate" @click="ChangeTypeDateRevenu($event); timeserchtype = 'betweendate';">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z" />
                            </svg>
                        </button>
                        <!--  -->
                    </div>
                    <!--  -->

                    <!--  -->
                    <div v-if="filter && timeserchtype == 'betweendate'" class="absolute z-10 rounded-lg right-0 bg-white date-container">
                        <!--  -->
                        <div class="inline-block mt-2 w-2/5 pr-1">
                            <!--  -->
                            <div class="border hover:border-orange-400 w-full focus-within:border-orange-500 focus-within:text-orange-500 transition-all duration-500 relative rounded p-1">
                                <!--  -->
                                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                    <p>
                                        <label for="date" class="bg-white text-gray-700 px-1">From 
                                            <span class="text-orange-500">*</span>
                                        </label>
                                    </p>
                                </div>
                                <!--  -->

                                <!--  -->
                                <p>
                                    <input :name="action" v-model="fromDate" class="w-full px-1 py-1 text-gray-700 bg-gray-200 rounded" id="from" type="date" />
                                </p>
                                <!--  -->
                            </div>
                            <!--  -->
                        </div>
                        <!--  -->

                        <!--  -->
                        <div class="inline-block mt-2 w-2/5 pr-1">
                            <!--  -->
                            <div class="border hover:border-orange-400 w-full focus-within:border-orange-500 focus-within:text-orange-500 transition-all duration-500 relative rounded p-1">
                                <!--  -->
                                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                    <p>
                                        <label for="date" class="bg-white text-gray-700 px-1">To 
                                            <span class="text-orange-500">*</span>
                                        </label>
                                    </p>
                                </div>
                                <!--  -->

                                <!--  -->
                                <p>
                                    <input :name="action" v-model="toDate" class="w-full px-1 py-1 text-gray-700 bg-gray-200 rounded" id="to" type="date" />
                                </p>
                                <!--  -->
                            </div>
                            <!--  -->
                        </div>
                        <!--  -->

                        <!--  -->
                        <div class="inline-block mt-2 w-1/5 pr-1">
                            <button @click="FindRecords()" :disabled="fromDate == null || toDate == null" class="w-full px-2 py-2 text-white font-light tracking-wider bg-gray-900 rounded">
                                Find
                            </button>
                        </div>
                        <!--  -->
                    </div>
                    <!--  -->
                </div>
                <!--  -->
            </div>
            <!--  -->
        </div>
        <!--  -->

        <!--  -->
        <div v-if="datasAcounting" class="w-full flex flex-col lg:flex-row items-center px-4 pb-4 gap-4">
            <div v-for="(item, key) in datasAcounting" :key="key" class="w-full lg:w-1/2">
                <mini-stats icon='' :title='item.name' :currency="currencyW" :sum="item.sum" :count="item.count" />
            </div>
        </div>
        <!--  -->
    </div>
</template>

<script>
import MiniStats from '@/components/Cards/MiniStatCard.vue';
export default {
    components: {
        MiniStats
    },
    props: {
        statSubtitle: {
            default: 'Acounting',
        },
        loading: { required: false },
        timeserch: {},
        userType: { default: null },
        timeserchseller: {},
        titleRate: {},
        from: {},
        to: {},
        filter: {
            default: false,
        },
        statTitle: {},
        action: {},
        statArrow: {
            default: 'up',
            validator: function (value) {
                // The value must match one of these strings
                return ['up', 'down'].indexOf(value) !== -1;
            },
        },
        statPercent: {},
        // can be any of the text color utilities
        // from tailwindcss
        statPercentColor: {
            default: 'text-primary-500',
        },
        statDescripiron: {},
        currency: { default: false },
        count: { type: Number, default: 0 },
        datas: { type: Array },
        sellers: { default: null },
        datasAcounting: { type: Array },
        countText: {},
        rate: {},
        statIconName: {
            default: 'far fa-chart-bar',
        },
        // can be any of the background color utilities
        // from tailwindcss
        statIconColor: {
            type: String,
            default: 'bg-red-500',
        },
    },
    data() {
        return {
            timeserchtype: this.timeserch,
            fromDate: this.from,
            toDate: this.to,
            timeserchsellerselect: this.timeserchseller,
            fullPage: false,
            currencyW: ''
        };
    },
    async mounted() {
        await this.getCurrency();
    },
    computed: {
        warhouseSelected() {
            return this.$store.getters['wharhouse/warhouseSelected'];
        },
    },
    watch: {
        warhouseSelected: async function (oldVal, newVal) {
            await this.getCurrency();
        },
        timeserch: function () {
            this.timeserchtype = this.timeserch;
        },
    },
    methods: {
        async getCurrency() {
            await this.$store.dispatch('wharhouse/getCurrency').then(res => {
                this.currencyW = res;
            });
        },
        ChangeTypeDateRevenu: function (val) {
            this.$emit('ChangeTypeDateRevenu', val);
        },
        FindRecords: function () {
            this.$emit('FindRecords', this.action, this.fromDate, this.toDate);
        },
        ChangeSeller: function (val) {
            this.$emit('ChangeSeller', val);
        },
    },
};
</script>